import { drainFrames, emitFrame, parseFrameData } from './sseFrameParser'

export async function parseSseStream(stream, onFrame, opts = {}) {
  const reader = stream.getReader()
  const decoder = new TextDecoder()
  let buffer = ''

  try {
    while (true) {
      if (opts.signal?.aborted) break
      const { value, done } = await reader.read()
      if (done) break
      buffer += decoder.decode(value, { stream: true })
      buffer = drainFrames(buffer, onFrame)
    }
    buffer += decoder.decode()
    if (buffer.trim()) emitFrame(buffer, onFrame)
  } finally {
    reader.releaseLock?.()
  }
}

export { parseFrameData }
